import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
`;
export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const Button = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 0.2rem;
	width: max-content;
	min-width: 18rem;
	padding: 1.4rem 1.2rem;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	cursor: pointer;
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
	&.primary {
		background-color: ${(props) => props.theme.colors.primary400};
		color: #fff;
	}
	@media screen and (max-width: 600px) {
		width: 100%;
	}
`;

export const ContentDescription = styled.p`
	color: var(--Colors-Font---color-font-darker, #212529);
	font-size: 1.8rem;
	font-style: normal;
	font-weight: 400;
	line-height: 140%;
	letter-spacing: -0.6px;
`;
